import { useMemo } from 'react'
import moment from 'moment'
import Badge from 'components/Badge'

import { Icon } from '../../../UI'

import { classLevels } from '../../../../constants'

import timerIcon from 'assets/icon/timer-icon.svg'
import timerIconGreen from 'assets/icon/timer-line-green.svg'

const TestCard = ({
  title,
  description,
  icon,
  level,
  nextAvailableDate,
  isPassed,
  className = '',
  result,
}) => {
  const isReview = result === 'pending'
  const classLevel = level
    ? classLevels.find((classLevel) => level === classLevel.value)
    : undefined

  const statusBg =
    isPassed == 'flagged' || result === 'pending'
      ? 'bg-yellow-200/60'
      : isPassed
        ? '!bg-success-50'
        : '!bg-error-50'
  const variant =
    isPassed == 'flagged' || result === 'pending' ? 'flagged' : isPassed ? 'success' : 'error'
  const statusColor =
    isPassed == 'flagged' || result === 'pending'
      ? '!text-yellow-600'
      : isPassed
        ? '!text-success-200'
        : '!text-error-200'

  const retryDate = useMemo(() => {
    const now = moment()

    if (!nextAvailableDate) {
      return 30
    }

    const nextAvailableDay = moment(nextAvailableDate)

    const days = nextAvailableDay.diff(now, 'days')

    if (days === 0) {
      return `${nextAvailableDay.diff(now, 'hours') || 1} hours`
    }
    if (days === 1) {
      return `${days} day`
    }

    return `${days} days`
  }, [nextAvailableDate])

  const isTestPassed = result?.toLowerCase() === 'pass'
  const isTestPending = result?.toLowerCase() === 'pending'

  const retry = (!isTestPassed && !isTestPending) || (level?.toLowerCase() !== 'expert' && isPassed)
  return (
    <div
      className={`bg-primary-500 !px-3 py-3 rounded-[10px] flex flex-col items-start justify-start relative ${statusBg} ${className}`}
    >
      <div className="w-full flex items-start justify-between">
        <div className="mb-3">
          <img className="block" src={icon} alt={title} />
        </div>

        <Badge className="text-sm" variant={variant}>
          {result === 'pending' ? (
            <div className="flex items-center mx-2">
              <span>Under Review</span>

              <Icon
                name="check-circle-fill"
                color="#FDFDFD"
                className="w-[16px] h-[16px] ml-[4px]"
              />
            </div>
          ) : !classLevel ? (
            <div className="flex items-center">
              <span>Failed</span>

              <Icon
                name="close-circle-fill"
                color="#FDFDFD"
                className="w-[16px] h-[16px] ml-[4px]"
              />
            </div>
          ) : (
            <div className="flex items-center">
              <span>Passed</span>

              <Icon
                name="check-circle-fill"
                color="#FDFDFD"
                className="w-[16px] h-[16px] ml-[4px]"
              />
            </div>
          )}
        </Badge>
      </div>

      <h3
        className={`text-primary-100 ${statusColor} font-semibold text-[18px] leading-[30px] relative inline-flex items-center justify-start mb-2`}
      >
        {title}

        {isPassed && (
          <span className="bg-white-100 py-1 px-2 ml-2 text-base rounded-lg">
            {classLevel?.label}
          </span>
        )}
      </h3>

      <p className={`max-w-[236px] !mb-2 w-full leading-6 text-warning-500 ${statusColor}`}>
        {description}
      </p>

      {retry && (
        <p
          className={`py-[5px] px-[10px] ${result === 'pending' ? 'bg-[#FFF8E1]' : isPassed ? 'bg-[#EDFFF3]' : 'bg-[#FFDCDC]'} rounded-[6px] ${statusColor} inline-flex items-center`}
        >
          <img className="mr-[6.5px]" src={isPassed ? timerIconGreen : timerIcon} alt="Timer" />
          <span className="text-sm">{retryDate} left to retry the test</span>
        </p>
      )}
    </div>
  )
}

export default TestCard
